import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';
import Header from '../../../../../../components/Stake/header';
import {
  OM,
  DAY,
  HOUR,
  LONG_CLAIM_PERIOD_AIRGRAB,
  SHORT_CLAIM_PERIOD_AIRGRAB,
} from '../../../../../../constants/blockchain-constants';
import StakeMore from '../../../../../../components/Stake/stake-more';
import Tooltip from '../../../../../../components/tooltip';
import stakeBackground from '../../../../../../assets/stake/stake-more-om.svg';
import stylesParent from '../../styles/frame/frame.module.scss';
import styles from '../../styles/main/main.module.scss';
import stylesNominate from '../../styles/main/main-nominate.module.scss';
import { LeaveIcon } from '../../../../../../constants/icon-constants';
import { formatToken } from '../../../../../../helpers/token-helper';
import styled from 'styled-components';
import PolygonLogo from '../../../../../../external/components/Icon/polygon';

const PolyLogo = styled(PolygonLogo)`
  width: 34px;
  height: 34px;
  margin-right: 0.25rem;
  margin-left: 0.25rem;
`;

const tooltipClaimText = `
KSM nominators can choose from a “Short Claim”
or “Long Claim”. This is meant to balance
the incentives between external communities
and the MANTRA DAO Sherpas.`;

const calculateAwailableTime = (timestamp, long) => {
  const now = Date.now();
  const diff = now - timestamp * 1000;
  const daysInDiff = Math.floor(diff / DAY);
  const dateDiff = (long ? LONG_CLAIM_PERIOD_AIRGRAB : SHORT_CLAIM_PERIOD_AIRGRAB) - daysInDiff;
  const hoursDiff = 24 - (Math.floor(diff / HOUR) % 24);
  return { dateDiff, hoursDiff };
};

const renderWithdrawItem = (item, index, setStatus) => {
  const long = item.isFullWithdrawal;
  const { amount } = item;
  const title = long ? 'Long' : 'Short';
  const { dateDiff, hoursDiff } = calculateAwailableTime(item.timestamp, long);
  const isNotAwailable = dateDiff >= 0 && hoursDiff >= 0;
  return (
    <div className={stylesNominate.sectionBody}>
      <Tooltip className={stylesNominate.sectionTooltip} label={`Available ${OM} for Withdrawal`} />
      <div className={cn(stylesNominate.sectionValue, stylesNominate.active)}>
        <b>{title} Claim:</b> <span>{formatToken(amount)} OM</span>
      </div>
      <div className={stylesNominate.sectionTime}>
        {isNotAwailable ? (
          <>
            in: <span>{dateDiff}</span> Days, <span>{hoursDiff}</span> Hours
          </>
        ) : null}
      </div>
      <div className={stylesNominate.sectionControls}>
        <Button
          className={stylesNominate.secondaryButton}
          onClick={() => setStatus(5, index)}
          variant='outlined'
          disabled={isNotAwailable}
        >
          Withdraw
        </Button>
      </div>
    </div>
  );
};

const Main = ({ setStatus }) => {
  const dark = useSelector((state) => state.basic.dark);
  const unclaimedAmount = useSelector((state) => state.delegator.matic.unclaimedAmount) || 0;
  const requestedRewards = useSelector((state) => state.delegator.matic.requestedRewards);
  const disabled = unclaimedAmount === 0;

  return (
    <>
      <Header componentIcon={<PolyLogo />} title={`Delegator Rewards`} />
      <div className={cn(stylesNominate.container, { [stylesNominate.dark]: dark })}>
        <div
          style={{ marginBottom: '20px' }}
          className={cn(styles.stakeMoreWrapper, stylesNominate.stakeMoreWrapper)}
        >
          <a
            style={{ textDecoration: 'none' }}
            target='_blank'
            rel='noreferrer nofollow noopener'
            href='https://wallet.matic.network/staking/validators/43'
          >
            <StakeMore
              type={OM}
              title={<>Nominate More {LeaveIcon}</>}
              image={stakeBackground}
              onClick={() => {}}
            />
          </a>
        </div>
        <div className={stylesNominate.sections}>
          <div className={stylesNominate.section}>
            <div className={stylesNominate.sectionBody}>
              <Tooltip
                className={stylesNominate.sectionTooltip}
                label={`Unclaimed ${OM} Rewards`}
                text={<div className={stylesParent.tooltipText}>{tooltipClaimText}</div>}
              />
              <div className={cn(stylesNominate.sectionValue, stylesNominate.active)}>
                {formatToken(unclaimedAmount)} OM
              </div>
              <div className={stylesNominate.sectionControls}>
                <Button
                  className={stylesNominate.secondaryButton}
                  onClick={() => setStatus(3)}
                  variant='outlined'
                  disabled={disabled}
                >
                  Short Claim
                </Button>
                <Button
                  className={stylesNominate.secondaryButton}
                  onClick={() => setStatus(4)}
                  variant='outlined'
                  disabled={disabled}
                >
                  Long Claim
                </Button>
              </div>
            </div>
          </div>
          {requestedRewards && !!requestedRewards.length ? (
            <div className={stylesNominate.section}>
              {requestedRewards.map((reward, i) => renderWithdrawItem(reward, i, setStatus))}
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

Main.propTypes = {
  setStatus: PropTypes.func.isRequired,
};

export default Main;
